import { IParameters } from '../intefaces/IParameters';

export enum INPUT_TYPE {
  text = 'TEXT',
  textArea = 'TEXTAREA',
  number = 'NUMBER',
  outputText = 'OUTPUTTEXT',
  boolean = 'BOOLEAN',
  oneOfMany = 'ONEOFMANY',
}

export const isPlainObject = (o) => {
  try {
    return typeof o === 'object' && o.constructor === Object;
  } catch (e) {
    return false;
  }
};

function getValueForRadio(form, input) {
  if (form[input.name].length) {
    return Array.prototype.reduce.call(
      form[input.name],
      (curr, acc) => (curr.checked ? curr : acc),
      form[input.name][0],
    ).value;
  } else {
    return form[input.name].value;
  }
}

function getValueForNumber(input) {
  if (!input.checkValidity()) {
    const maxValue = Math.abs(Number(input.max) - input.dataset.value);
    const minValue = Math.abs(Number(input.min) - input.dataset.value);

    return maxValue > minValue ? input.min : input.max;
  } else {
    return input.dataset.value;
  }
}

export const getInputValues = (form: HTMLFormElement): any[] => {
  const inputsMap = {};

  Array.prototype.forEach.call(form.elements, (input) => {
    let value;

    if (input.name && !inputsMap[input.name]) {
      switch (input.type) {
        case 'button':
          value = String(input.value);
          break;
        case 'checkbox':
          value = String(input.checked);
          break;
        // simpler/better methods of getting a selected value from radio group exist,
        // but this finds the selected radio button value which works for ie11 and modern browsers
        case 'radio':
          value = getValueForRadio(form, input);
          break;
        case 'text':
          value = String(input.value);
          break;
        case 'number':
          value = getValueForNumber(input);
          break;
        default:
          value = input.value;
          break;
      }
    }

    if (value) {
      inputsMap[input.name] = { id: input.name, value };
    }
  });

  return Object.values(inputsMap);
};

function vinReader(vin: string): IVIN {
  if (vin.length === 17) {
    const manufacturerCode = vin.slice(0, 3);
    const baumuster = vin.slice(3, 9);
    const steeringSide = vin.slice(9, 10);
    const productionPlant = vin.slice(10, 11);
    const serialNumber = vin.slice(11);
    return {
      manufacturerCode,
      baumuster,
      steeringSide,
      productionPlant,
      serialNumber,
    };
  } else {
    throw new Error('Invalid VIN.');
  }
}

export function baumusterExtractor(vin: string): string {
  return vinReader(vin).baumuster;
}

export const getEnvPrefix = (currentEnv: string) => {
  const envs = {
    test: 'test.',
    production: '',
    development: 'dev.',
  };

  return envs[currentEnv] || '';
};

export function getURLParameters(): IParameters {
  const queryParams = window.location.search.substring(1).split('&');

  return queryParams.reduce((acc, curr) => {
    const result = curr.split('=');

    const key = result[0];
    let value: any = result[1];

    if (key === 'price' || key === 'purchasePrice') {
      value = Number(value);
    }

    acc[key] = value;

    return acc;
  }, {});
}
